import { Engine } from "@babylonjs/core/Engines/engine";
var ViewerGlobals = /** @class */ (function () {
    function ViewerGlobals() {
        this.disableInit = false;
        this.disableWebGL2Support = false;
    }
    Object.defineProperty(ViewerGlobals.prototype, "version", {
        get: function () {
            return Engine.Version;
        },
        enumerable: false,
        configurable: true
    });
    return ViewerGlobals;
}());
export { ViewerGlobals };
export var viewerGlobals = new ViewerGlobals();
//# sourceMappingURL=globals.js.map